/**
 * @generated SignedSource<<ebf9ec28060b3de16f2be3d7b8afe7ba>>
 * @relayHash 41e68418d50dd1499210e4f98bb572d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7efbe0412260f4ec4a164de27afad932d212799fe189b506e65c7ecc28f5cb2c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServiceDeskPortalSettingsQuery$variables = {
  cloudId: string;
};
export type ServiceDeskPortalSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CustomerPortalSettingsPage">;
};
export type ServiceDeskPortalSettingsQuery = {
  response: ServiceDeskPortalSettingsQuery$data;
  variables: ServiceDeskPortalSettingsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider: {
    readonly get: () => boolean;
  };
});

import rovoAgentConfigExperienceFG_provider from '@atlassian/jira-relay-provider/src/jsm-portal-rovo-agent-config-experience.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyEditableAgents": true
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CustomerPortalSettingsPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              },
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "creatorType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v2/*: any*/),
            "filters": [
              "cloudId",
              "input"
            ],
            "handle": "connection",
            "key": "RovoAgent_agentStudio_getAgents",
            "kind": "LinkedHandle",
            "name": "agentStudio_getAgents"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7efbe0412260f4ec4a164de27afad932d212799fe189b506e65c7ecc28f5cb2c",
    "metadata": {},
    "name": "ServiceDeskPortalSettingsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider
    }
  }
};
})();

(node as any).hash = "c5f5439b89a531ccf42b97aa657752b9";

export default node;
